<template>
  <fieldset
    class="min-h-[20em]"
    :class="tabConfiguration && tabConfiguration.class"
  >
    <template v-for="(comp, index) in configuration">
      <component
        v-if="!(comp.type && comp.type === 'section')"
        class="p-4"
        :key="index"
        :is="comp.type + 'Option'"

        :configuration="configuration"
        :config="config"
        :block-id="id"
        :role="role"

        :options="comp.options"
        :title="comp.title"
        :default="comp.default"
        :description="comp.description"
        :id="comp.id"
      />
      <div v-else :key="index" class="flex justify-between p-4" :class="index && 'border-t border-gray-200'">
        <h4 class="font-semibold">{{ comp.label }}</h4>
        <div :class="comp.class || 'grid grid-cols-1'" class="!min-w-[33em]">
          <component
            v-for="(comp, index) in comp.children"
           :is="comp.type + 'Option'"
            :key="index"
           :configuration="configuration"
           :config="config"
           :block-id="id"
           :role="role"

           :options="comp.options"
           :title="comp.title"
           :default="comp.default"
           :description="comp.description"
           :id="comp.id"
          />
        </div>
      </div>
    </template>
  </fieldset>
</template>

<script>

import CheckboxOption from "./CheckboxOption"
import NumberOption from "./NumberOption"
import TextOption from "./TextOption"
import SelectOption from "./SelectOption"

export default {
  components: {
    CheckboxOption,
    NumberOption,
    TextOption,
    SelectOption,
  },
  props: ['configuration', 'config', 'id', 'role', 'tabConfiguration'],
  data() {
    return {

    }
  },
}

</script>
